import { GetSpareStockReqDto } from "@gtpl/shared-models/asset-management";
import { EntityRepository, Repository } from "typeorm";
import { SpareStockEntity } from "../entities/spare-stock-entity";
import { SpareStockStatusEnum } from "@gtpl/shared-models/common-models";

@EntityRepository(SpareStockEntity)
export class SpareStockRepository extends Repository<SpareStockEntity>{

    async getSpareStockData(req: GetSpareStockReqDto) {
        const query = this.createQueryBuilder()
            .select(`
            pch,
            customer,
            brand,
            name,
            description,
            location,
            color,
            remarks,
            uom,
            receipt,
            age,
            quantity,
            value,
            warehouse,
            supplier,
            status,
            hsn_code as hsncode,
            item_number as item,
            location_description as locationdescription,
            lot_number as lot,
            lot_reference1 as lotRef1,
            lot_reference2 as lotRef2,
            buyer_description as buyerdescription,
            ageing_range as ageingrange,
            po_no as poNo,
            stock_zone as stockzone,
            mode_of_transport as modeoftransport,
            is_active as isActive,
            created_at as createdAt,
            created_user as createdUser,
            updated_at as updatedAt,
            updated_user as updatedUser,
            version_flag as versionFlag,
            file_path as filepath
            `)
     
        if (req.allStockType) {
            query.andWhere(`all_stock_type = "${req.allStockType}"`)
        }
        if (req.warehouse) {
            query.andWhere(`warehouse = '${req.warehouse}'`)
        }
        if (req.pch) {
            query.andWhere(`pch = '${req.pch}'`)
        }
        if (req.procurementGroup) {
            query.andWhere(`procurement_group = "${req.procurementGroup}"`)
        }
        if (req.stockZone) {
            query.andWhere(`stock_zone = "${req.stockZone}"`)
        }
        if (req.location) {
            query.andWhere(`location = "${req.location}"`)
        }
        if (req.locationDescription) {
            query.andWhere(`location_description = '${req.locationDescription}'`)
        }
        if (req.productGroup) {
            query.andWhere(`product_group = '${req.productGroup}'`)
        }
        if (req.orderType) {
            query.andWhere(`order_type = "${req.orderType}"`)
        }
        if (req.statusProposal) {
            if (req.statusProposal === "All") {
                query.andWhere(`status = "${req.statusProposal}" and status = "${SpareStockStatusEnum.ALLOCATED}" and status = "${SpareStockStatusEnum.OPEN}" and status = "${SpareStockStatusEnum.CONSUMED}"`)
            } else {
                query.andWhere(`status = "${req.statusProposal}"`)
            }
        }
        query.andWhere('age >= 0')
        const data = await query.getRawMany()
        console.log(data, "datadatadata")
        return data
    }

}



